import React, { useState } from "react";
import { Resizable } from "re-resizable";
import { compose } from "redux";
import actions from "fantastic/actions";
import setResizing from "fantastic/actions/setResizing";
import connectActions from "fantastic/lib/connectActions";
import styles from "fantastic/components/hoc/styles";
import utils from "fantastic/lib/utils";

const Spacer = props => {
  const {
    id,
    style,
    preview,
    update,
    height,
    setResizing,
    meta: { selected, resizing = false }
  } = props;
  if (preview) {
    return <div style={style} />;
  }

  const [scale, setScale] = useState(null);

  const onResizeStart = () => {
    setScale(parseInt(height));
    setResizing(id, true);
  };

  const onResize = (e, direction, ref, d) => {
    setScale(parseInt(height) + d.height);
  };

  const onResizeStop = (e, direction, ref, d) => {
    const curHeight = parseInt(height);
    update(id, { ["height"]: (curHeight + d.height).toString() });
    setResizing(id, false);
  };
  const handler = selected && (
    <div className="fantastic-spacer__handler btn btn-default btn-xs">
      <i className="fa fa-arrows-v"></i>
    </div>
  );

  const enable = {
    top: false,
    right: false,
    bottom: true,
    left: false,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false
  };
  return (
    <Resizable
      size={{ height: parseInt(height), width: "auto" }}
      onResizeStart={onResizeStart}
      onResize={onResize}
      onResizeStop={onResizeStop}
      handleComponent={{ bottom: handler }}
      enable={enable}
    >
      <div className="fantastic-spacer" style={style}>
        {selected && (
          <div className="fantastic-spacer__value">
            {resizing ? utils.px(scale) : style.height}
          </div>
        )}
      </div>
    </Resizable>
  );
};

export default compose(
  styles("background", "height", "border"),
  connectActions({
    update: actions.updateNode,
    setResizing
  })
)(Spacer);
